// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"styles_boxContainer__Ib7sZ"};